/**
 * Password rules both sides have to agree on.
 *
 * The minimum lived in three places — the hashing service, the sign-in screen
 * and the user admin screen — which meant changing it once left two copies
 * disagreeing, and the disagreement only showed up as a rejected password after
 * someone had typed it twice.
 */

export const MIN_PASSWORD_LENGTH = 8;

/** A cap so nobody hands the hasher a megabyte to chew on. */
export const MAX_PASSWORD_LENGTH = 128;
